export default __webpack_public_path__ + "static/media/instantECardUsagehelp.0709ee09.png";